<template>
	<div class="login">
		<div class="login__holder">
			<div class="login-block--form login__box">
				<div class="login__box-wrap">
					<div class="login__branding fade-in one">
						<router-link class="login__logo" to="/">
							<img class="login__logo-img" src="@/assets/images/logo.png" alt="Logo" title="">
						</router-link>
					</div>
					<transition name="fade-in">
						<div class="login-block__form fade-in two">
							<transition name="fade">
								<ValidationObserver v-slot="{ handleSubmit }">
									<form action="" class="login-form forget-pass--form" @submit.prevent="handleSubmit(submit)">
										<div class="login-form__top">
											<h2 class="block-title login-form--title">Forgot Password!</h2>
											<p class="login-form--text">Link to the password reset form will be sent to your email address</p>
										</div>
										<div class="notification-wrap-form">
											<PartNotifications :data="notificationsData" @closeNotificaiton="closeNotificaiton" v-if="notificationsData.msg" />
										</div>
										<div class="login-form__body">
											<div class="login-form-fieldset input-holder">
												<label for="reset-email" id="email-label" class="input-label">Email</label>
												<ValidationProvider rules="required|email" v-slot="{ errors }" class="error-message-holder error-message-holder--block" ref="inputEmailValidator">
													<PartInputBasic v-model="email" :data="DataInputEmail" ref="inputEmail"/>
													<span class="error-message" v-if="errors[0]">{{ errors[0]}}</span>
													<!-- <span class="login-form__error notice-message" v-show="noticeText" v-else>{{noticeText}}</span> -->
												</ValidationProvider>
											</div>
										</div>
										<div class="login-form-fieldset login-form--submit error-message-holder">
											<button type="submit" :disabled="disabled" class="btn login-form-submit-btn" id="login_forgot-button">
												<PartLoader v-if="showLoader"/>
												Send Reset Link</button>
											<div class="login-form__fp">
												<router-link :to="link" id="forgot_back_login-button">Back to Login</router-link>
											</div>
										</div>
									</form>
								</ValidationObserver>
							</transition>
						</div>
					</transition>
				</div>
			</div>
			<transition name="fade-in">
				<PartLoginImage :data="DataLoginImage"/>
			</transition>
		</div>
	</div>
</template>

<script>

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import PartLoader from '@/components/parts/PartLoader';
import PartInputBasic from '@/components/parts/PartInputBasic';
import PartLoginImage from '@/components/parts/PartLoginImage.vue';
import PartNotifications from '@/components/parts/PartNotifications';

extend('email', {
	...required,
	message: 'This field is mandatory.'
});

extend('email', {
	...email,
	message: 'Email must be in correct format.'
});

extend('required', {
	...required,
	message: 'This field is mandatory.'
});

export default {
	components: {
		ValidationProvider,
		ValidationObserver,
		PartLoader,
		PartInputBasic,
		PartLoginImage,
		PartNotifications
	},
	data () {
		return {
			notificationsData: {
				type: '',
				msg: '',
				hasCloseIcon: true
			},
			DataLoginImage: {},
			email: '',
			showLoader: false,
			disabled: false,
			DataInputEmail: {
				inputId: 'email_forgot-input',
				name: 'email',
				minlength: 6,
				type: 'text',
				inputVal: 'email'
			}
		};
	},
	computed: {
		link() {
			// Append email to forgot-password email if valid
			if (this.email && this.$refs?.inputEmailValidator?.errors?.length === 0) {
				return `/login?email=${this.email}`;
			}

			return '/login';
		}
	},
	watch: {
		email() {
			if (this.email === '') {
				this.disabled = false;
			}
		}
	},
	mounted() {
		if (this.$route.query.email) {
			this.email = this.$route.query.email;
			this.$refs.inputEmail.setValue(this.email);
		}
	},
	methods: {
		closeNotificaiton() {
			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 500);
		},
		submit() {
			// Bail if already in progress
			if (this.showLoader || this.disabled) {
				return;
			}

			// Remove current error messages
			this.showLoader = true;

			this.$store.dispatch('sendResetPasswordRequest', this.email).then(
				response => this.handleSuccess(response),
				error => this.handleError(error)
			);
		},

		notification(msg, type) {
			this.notificationsData.msg = msg;
			this.notificationsData.type = type;
		},

		handleSuccess({ data }) {
			this.notification('Email will be sent if the address provided is valid.', 'success');
			this.showLoader = false;
			this.disabled = true;
		},

		handleError(error) {
			this.showLoader = false;
			this.notification('Email will be sent if the address provided is valid.', 'success');
			this.disabled = true;
			return Promise.resolve(error);
		}
	}
};
</script>
<style lang="scss" scoped>
.login__branding {
	margin-bottom: 96px;

	@include mq ($lg) {
		margin-bottom: 50px;
	}
}

.login__logo {
	color: $white;
	display: block;
	max-width: 119px;
	margin: 0 auto;

	@include mq($xl) {
		max-width: 95px;
	}

	@include mq($lg) {
		max-width: 85px;
	}
}

.login__logo-img {
	display: block;
	width: 100%;
}

.login {
	overflow: hidden;

	@include mq ($lg) {
		overflow: auto;
	}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.login-form-fieldset {
	margin-bottom: 27px;
}

.login-form--text {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $fiord;
    letter-spacing: 0.08px;
}

.login-form-fieldset {
	margin-bottom: 30px;

	@include mq ($lg) {
		margin-bottom: 20px;
	}
}

.login-block__form {
	width: 100%;
}

.login-form {
	transition: $dur $ease;
	input {
		display: block;
		box-shadow: none;
		border: 1px solid $grey-light;
		padding: 15px 20px;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		background-color: $white;

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}

.login__holder {
    display: flex;
    min-height: 100vh;

	@include mq($lg) {
		padding: 40px 0;
	}
}

.login__box {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 46%;
    flex: 1 0 46%;
	height: 100%;
    margin: auto;

	@include mq($lg) {
		max-width: 390px;
		width: 100%;
		flex: auto;
	}
}

.login__box-wrap {
	display: flex;
	flex-direction: column;
	height: 100%;
	align-items: center;
	justify-content: center;
	width: 100%;
	max-width: 392px;
	padding: 0 15px;
}

.login-block__form {
    text-align: center;
	height: 100%;
    display: flex;
    align-items: center;
	width: 100%;
	max-width: 100%;
}

.login-form--title {
    margin-bottom: 20px;
}

.login-form__body {
    padding: 67px 0 0;
}

.login-form-submit-btn {
    width: 100%;
    position: relative;
	cursor: pointer;
	max-width: 100% !important;//sass-lint:disable-line no-important
	padding: 10px !important;//sass-lint:disable-line no-important
}

.login-form__fp {
    display: flex;
	text-align: center;
	justify-content: center;
    margin-top: 26px;

	a {
		color: $dodger-blue;
		transition: $dur $ease;

		@include hover {
			color: $fiord;
            opacity: 0.9;
        }
	}
}

.login-form__signup {
    font-size: 16px;
    letter-spacing: 0.1px;
    line-height: 1.2;
    font-weight: 400;
    color: $fiord;

    a {
        color: $fiord;
        transition: $dur $ease;
        font-weight: 700;

        @include hover {
            opacity: 0.9;
            color: $dodger-blue;
        }
    }
}

.login-form--submit {
    margin-bottom: 64px;
    position: relative;
}

.forget-pass--form {
    .login-form-body {
        padding-top: 40px;
    }
}

.input-label {
	text-align: left;
}

.block-title {
	display: block;
	font-family: $font-main;
	font-weight: 500;
	font-size: 24px;
	line-height: 1.2;
	color: $fiord;
}

.input-holder,
.input-holder__pass {
	position: relative;
}

.show-pass {
	position: absolute;
	top: 56%;
	right: 10px;
	transform: translateY(-50%);
	font-size: 14px;
	color: $fiord;
	transition: $dur $ease;

	@include hover {
		color: $dodger-blue;
	}
}

.notice-message {
    font-family: $font-main;
    font-size: 14px;
    line-height: 1.2;
    color: $fiord;
    padding: 0 15px;
    display: block;
    line-height: 1.3;

    @include mq($sm) {
        font-size: 13px;
        padding: 0 30px;
    }
}
</style>
